import { useState, useEffect } from 'react';
import { getLogoUrl } from '../firebase/storage';

export const useLogoUrl = () => {
  const [logoUrl, setLogoUrl] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLogoUrl = async (cacheBuster?: string) => {
    try {
      setLoading(true);
      setError(null);
      console.log('[useLogoUrl] Fetching logo URL');
      
      const url = await getLogoUrl();
      console.log('[useLogoUrl] Got logo URL:', url);
      
      setLogoUrl(url);
      setError(null);
    } catch (err) {
      console.error('[useLogoUrl] Error fetching logo:', err);
      setError('Failed to load logo');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogoUrl();
  }, []);

  const refreshLogo = () => {
    console.log('[useLogoUrl] Refreshing logo');
    fetchLogoUrl();
  };

  return { logoUrl, loading, error, refreshLogo };
};

export default useLogoUrl;
